import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import CatalogueView from "@/components/Catalogue/CatalogueView.vue";
import { get_user_details } from "@/router";
import { get_active_organization_id, is_enabled_feature, is_organization_admin_role } from "@/utils/organization_profile";
import { services_helpers } from "./services_helper";
import { create_marketplace_catalogue_realtime_methods } from "@/views/Marketplace/marketplace_realtime_helper";
import {
    create_item_form,
    create_update_item_form,
    services_view_methods
} from "./services_view_helper";

const services_realtime_methods = create_marketplace_catalogue_realtime_methods({
    listing_type: "service",
});

export default {
    name: "ServicesView",
    components: {
        HomeNavBar,
        CatalogueView,
    },
    inject: ["client_features"],
    watch: {
        service_types: {
            handler(new_types) {
                this.apply_default_service_type(new_types);
            },
            deep: true,
            immediate: true,
        },
        '$route.params.tab': {
            immediate: true,
            handler() {
                this.apply_route_tab();
            },
        },
    },
    data() {
        return ({
            loading: true,
            errors: {},
            user_details: get_user_details() || {},
            base_profile_id: null,
            active_home_profile: null,
            shop_profile: null,
            active_tab: "services",
            profile_products: [],
            catalogue_services: [],
            product_types: [],
            requests: [],
            isLoading: false,
            create_action_loading: null,
            isEditing: false,
            is_deleting: false,
            isDragging: false,
            modal_product: "",
            upload_files: [],
            previews: [],
            active_modal_image_index: 0,
            categories: [],
            subcategories: [],
            selected_category: "",
            selected_subcategory: "",
            service_types: [],
            attributeTypes: [],
            new_attribute_value: {},
            modalType: "service",
            item_form: create_item_form(),
            update_item_form: create_update_item_form(),
        });
    },
    computed: {
        is_dropin_selected() {
            const selected_type = this.service_types.find((type) => type.id === this.item_form.service_type_id);
            return selected_type?.name === "drop_in";
        },
        catalogue_items() {
            return this.catalogue_services;
        },
        is_services_page() {
            return true;
        },
        can_create_business_profile_action() {
            return is_enabled_feature(this.client_features?.show_business_profile)
                && !is_organization_admin_role(this.user_details);
        },
        service_create_permission() {
            return get_active_organization_id() ? "services" : null;
        },
        add_item_label() {
            return "Service";
        },
        add_item_modal_type() {
            return "service";
        },
        pending_requests() {
            return this.requests || [];
        },
        catalogueTab() {
            return this.active_tab;
        },
        view_model() {
            return this;
        },
        isDeleting: {
            get() {
                return this.is_deleting;
            },
            set(value) {
                this.is_deleting = value;
            },
        },
        page_title() {
            return this.active_home_profile?.profile_name
                || this.active_home_profile?.company_name
                || "My Services";
        },
    },
    mounted() {
        this.loading = true;
        this.get_active_base_services()
            .then(() => Promise.allSettled([
                this.fetch_product_types(),
                this.get_attribute_types(),
                this.get_requests(),
            ]))
            .catch((error) => {
                this.errors.page_load = error?.message || "Failed to load service data.";
            })
            .finally(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.apply_route_tab();
                    this.initialize_add_item_location_autocomplete();
                    this.open_actions_offcanvas_from_route();
                });
            });
        window.addEventListener("realtime:event", this.handle_marketplace_listing_realtime_event);
    },
    beforeUnmount() {
        window.removeEventListener("realtime:event", this.handle_marketplace_listing_realtime_event);
    },
    methods: {
        ...services_view_methods,
        ...services_helpers,
        ...services_realtime_methods,
        apply_route_tab() {
            const route_tab = String(this.$route.params.tab || '').toLowerCase().trim();
            this.active_tab = route_tab === 'requests' ? 'requests' : 'services';

            if (route_tab === 'requests') {
                const query_string = new URLSearchParams(this.$route.query).toString();
                const clean_url = query_string ? `/my_services?${query_string}` : '/my_services';
                window.history.replaceState({}, '', clean_url);
            }
        },
        open_actions_offcanvas_from_route() {
            this.open_actions_offcanvas("myServicesActionsOffcanvas");

            if (this.$route.query.open_actions === "1") {
                this.$router.replace({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: {
                        ...this.$route.query,
                        open_actions: undefined,
                    },
                });
            }
        },
        open_actions_offcanvas(offcanvas_id) {
            const offcanvas_el = document.getElementById(offcanvas_id);
            if (!offcanvas_el) return;

            if (window.bootstrap?.Offcanvas) {
                window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas_el).show();
                return;
            }

            $(`#${offcanvas_id}`).offcanvas("show");
        },
    },
};
